import { TOPIC_NAMES_KEY } from '../constants';
import { getModule } from '../modules/container';
import StorageService from '../services/StorageService';

type SelectedLibraryPayload = {
  SelectedLibraryData?: {
    libraryList?: { topicNames?: string[] }[];
  };
  libraryList?: { topicNames?: string[] }[];
};

export const extractTopicNames = (data: SelectedLibraryPayload | null | undefined): string[] => {
  const libraryList = data?.SelectedLibraryData?.libraryList ?? data?.libraryList ?? [];

  return libraryList?.[0]?.topicNames?.filter(Boolean) ?? [];
};

export const persistTopicNames = async (topicNames?: string[] | null) => {
  const storageService = getModule(StorageService);

  if (topicNames?.length) {
    await storageService.setItem(TOPIC_NAMES_KEY, JSON.stringify(topicNames));
    return;
  }

  await storageService.removeItem(TOPIC_NAMES_KEY);
};

export const syncTopicNamesFromSelectedLibraryJson = async (json: string) => {
  try {
    const parsed = JSON.parse(json) as SelectedLibraryPayload;
    await persistTopicNames(extractTopicNames(parsed));
  } catch {
    await persistTopicNames(null);
  }
};

export const syncTopicNamesFromSelectedLibraryData = async (data: unknown) => {
  await persistTopicNames(extractTopicNames(data as SelectedLibraryPayload));
};

export const getStoredTopicNames = async (): Promise<string[]> => {
  const storageService = getModule(StorageService);
  const topicNames = await storageService.getItem<string[]>(TOPIC_NAMES_KEY, true);

  return topicNames ?? [];
};
